// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Header_logoWrapper__x2lIq","navBarWrapper":"Header_navBarWrapper__g3AmB"};